<template>
  <div class="panel-middle">
    <h3 class="panel-top-name">{{ title }}</h3>
    <div class="custom-label" v-if="name === 'home'"
      style="color:#565656; margin-top: 20px; font-style: italic;margin-bottom: 15px;">
      {{ $static('te.t222', 'Рекомендований розмір 1200 x 500 px. Крім того, радимо оптимізувати зображення') }}
    </div>
    <div class="files-uploader default-files-uploader" v-if="name === 'home'">

      <div class="files-uploader-holder" v-if="!settings.image || settings.image.length === 0" @click="openFileManager">
        <span class="icon icon-cloud-upload"></span>
        <p>{{ $static('ei.tf1', 'Завантажте свої зображення сюди') }}</p>
        <span>{{ $static('ei.tf2', 'Зображення повинні мати розширення .png або .jpg') }}</span>
      </div>
      <div class="uploader-previews" @click="openFileManager" v-else>
        <div class="image bg" v-for="(image, index) in settings.image"
          :style="{ backgroundImage: $filters.backgroundImage(image.url) }">
          <a href="javascript:void(0)" class="btn-icon btn-remove btn-small" @click.prevent.stop="delImage(index)">
            <span class="icon icon-trash-filled"></span>
          </a>
          <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, -1)"
            style="bottom: inherit;top: 3px;left: 3px;">
            <span class="icon icon-left"></span>
          </a>
          <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, 1)"
            style="bottom: inherit;top: 3px;right: 3px;">
            <span class="icon icon-right"></span>
          </a>
        </div>

      </div>
      <div class="image image-placeholder ">
        <div class="text">1200 x 500</div>
      </div>
    </div>

    <div class="row" v-if="name === 'home'">
      <div class="col">
        <h3 class="mb-2">{{ $static('ei.tf222', 'Слайдер на головній сторінці') }}</h3>
        <div class="image home-slider panel panel-bordered d-flex align-items-center"
          v-for="(image, index) in settings.image" :key="index">
          <img :src="image.url" alt=""
            style="max-width: 80px; width:80px; margin-right: 10px; border-radius: 7px; align-self: center;">
          <label style="padding: 0px 5px;">
            <span class="custom-label">{{ $static('te.ln1', 'Посилання') }}</span>
            <input type="text" class="form-control custom-input" v-model.trim="image.link">
          </label>

          <!-- Данный функционал настройки слайдера пока не востребован и не доведен до ума-->
          <!-- <label  style="padding: 0px 5px;">
            <span class="custom-label">{{$static('te.ln2', 'Заголовок')}}</span>
            <input type="text" class="form-control custom-input" v-model="image.title">
          </label>
          <label  style="padding: 0px 5px;">
            <span class="custom-label">{{$static('te.ln3', 'Підаголовок')}}</span>
            <input type="text" class="form-control custom-input" v-model="image.subtitle">
          </label>
          <label  style="padding: 0px 5px;">
            <span class="custom-label">{{$static('te.ln4', 'Ціна')}}</span>
            <input type="text" class="form-control custom-input" v-model="image.price">
          </label> -->
          <!--          
          <label>-->
          <!--            title-->
          <!--            <input type="text" v-model="image.title">-->
          <!--          </label>-->
          <!--          <label>-->
          <!--            subtitle-->
          <!--            <input type="text" v-model="image.subtitle">-->
          <!--          </label>-->
          <!--          <label>-->
          <!--            price-->
          <!--            <input type="text" v-model="image.price">-->
          <!--          </label>-->
          <!--          <label>-->
          <!--            new-->
          <!--            <input type="checkbox" v-model="image.new">-->
          <!--          </label>-->
          <!-- <div class="option-box mt-0 w-10" style="margin-left: 10px;">
            <div class="option-line">
              <div class="option-name">new</div>
              <div class="toggle-holder">
                <div class="toggler r">
                  <input type="checkbox" class="toggle-check" v-model="image.new">
                  <div class="knobs"></div>
                  <div class="layer"></div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <div class="custom-editor-holder custom-pages-editor" v-if="basicLang">
            <editor v-model="html" :small="false"></editor>
          </div>
          <div class="custom-editor-holder custom-pages-editor" v-else>
            <editor :small="false" :placeholder="html" v-model="translate.html"
              @update:modelValue="e => setTranslate('html', e)"></editor>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="form-group">
          <div class="custom-label">{{ $static('ceo.t1', 'Мета-тег Title') }}</div>
          <input type="text" class="form-control custom-input" v-model="settings.meta_title">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group">
          <div class="custom-label">{{ $static('ceo.t2', 'Мета-тег description') }}</div>
          <textarea class="form-control custom-input" v-model="settings.meta_description"></textarea>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-bottom">
    <button class="transparent-btn default-btn back_trigger" @click="$emit('cancel')">
      <span class="text">{{ $static('ei.cancel', 'Скасувати') }}</span>
    </button>
    <button class="default-btn btn-accent" @click="saveTemplate">
      <span class="text">{{ $static('ei.save', 'Зберегти зміни') }}</span>
    </button>
  </div>
</template>

<script>
import api from '@/api'
import Editor from './Editor';

export default {
  name: 'TemplateEditor',
  components: { Editor },
  emits: ['cancel'],
  props: ['title', 'name', 'lang'],
  data() {
    return {
      html: '',
      loading: false,
      result: {}
    }
  },
  mounted() {
    this.fetchTemplate(this.name);
    if (this.name === 'home') {
      api.get('/api/options').then(response => response.data).then(data => {
        this.$store.commit('setOptions', data)
      });
    }
  },
  computed: {
    translate: {
      get() {
        return this.lang && this.result.translate && this.result.translate[this.lang] ? this.result.translate[this.lang] : {}
      },
      set(value) {
        // if (this.lang){
        //   this.item.translate[this.lang] = value
        // }
      }
    },
    settings: {
      get() {
        if (!this.result.settings || Array.isArray(this.result.settings)) {
          this.result.settings = {}
        }
        return this.result.settings
      },
      set(value) {
        this.result.settings = value
      }
    },
    basicLang() {
      return this.lang === ''
    },
    categoriesOptions() {
      return this.categories ? this.categories.map(x => { return { label: x.name, value: x.id, url: x.info.url } }) : []
    },
    category: {
      get() {
        return this.categoriesOptions.find(x => x.url == this.settings.url)
      },
      set(value) {
        this.settings.url = value
      }
    },
    options() {
      return this.$store.getters.options
    },
    categories() {
      return this.getOptions('category')
    }
  },
  methods: {
    getOptions(id) {
      let value = this.options.find(i => i.option_id === id);
      if (value) {
        return value.list.sort((a, b) => a.order - b.order)
      }
      return value
    },
    setTranslate(key, value) {
      if (!this.result.translate) {
        this.result.translate = {}
      }
      if (!this.result.translate[this.lang]) {
        this.result.translate[this.lang] = {}
      }
      this.result.translate[this.lang][key] = value
    },

    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select)
    },
    delImage(index) {
      delete this.settings.image.splice(index, 1)
    },
    moveImage(index, target) {
      let n = index + target;
      if (n > -1 && n < this.settings.image.length) {
        [this.settings.image[index], this.settings.image[n]] = [this.settings.image[n], this.settings.image[index]]
      }
    },
    select() {
      // let images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path));
      // if (images) {
      //   this.result.settings = Object.assign({}, this.result.settings, {image: images[0]})
      // }
      if (!Array.isArray(this.settings.image)) {
        this.settings.image = []
      }
      let images = this.$store.getters['fm/selectedItems'].map(i => ({ url: encodeURI('/storage/' + i.path) }));
      this.settings.image.push(...images);
    },
    saveTemplate() {
      if (this.name === 'home') {
        console.log("first")
        if (!this.validateSliderLinks()) {
          console.log("second")
          return;
        }
      }
      let obj = Object.assign({}, this.result, { template: this.html, name: this.name });
      api.post('/api/template', obj).then(response => response.data).then(() => {
        // this.template[name] = data;
        this.$emit('cancel');
        this.$notify({
          title: this.$static('notify-page.title', 'Сторінка'),
          text: this.$static('notify.save', 'Збережено.'),
          duration: 3000
        });
      }).catch(error => {
        this.$notify({
          title: this.$static('notify-page.title', 'Сторінка'),
          text: this.$static('notify.save-error', 'Сталася помилка при збереженні.'),
          duration: 3000
        });
      })

    },
    fetchTemplate() {
      this.loading = true;
      api.get('/api/template/' + this.name).then(response => response.data).then(data => {
        this.html = data.template;
        this.loading = false;
        this.result = data;
        if (this.name === 'home' && !Array.isArray(this.result.settings.image)) {
          this.result.settings.image = [{
            url: this.result.settings.image,
            link: '/catalog/' + this.result.settings.url,
            title: this.result.settings.title,
            subtitle: this.result.settings.subtitle,
          }]
        }
      }).catch(() => this.loading = false)
    },
    validateURL(input) {
      const urlPattern = new RegExp(
        '^(https?:\\/\\/)' + // Протокол (http или https) — обязателен
        '(([a-zA-Z\\d-]+\\.)+[a-zA-Z]{2,}|' + // Доменное имя должно включать хотя бы одну точку и домен верхнего уровня
        'localhost|' + // Локальный хост
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // Или IP-адрес (v4)
        '(\\:\\d+)?' + // Необязательный порт
        '(\\/[-a-zA-Z\\d%@_.~+&:]*)*' + // Путь
        '(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?' + // Параметры
        '(\\#[-a-zA-Z\\d_]*)?$', // Хэш (якорь)
        'i'
      );

      return urlPattern.test(input);
    },

    validateSliderLinks() {
      let isValid = true;
      /* 1.Валидация ссылок в слайдах]' */
      if (Array.isArray(this.settings.image) && this.settings.image.length > 0) {
        // Проверяем каждую ссылку в массиве
        isValid = this.settings.image.every(image => {
          if (!image.link) { return true; }

          if (!this.validateURL(image.link)) {
            this.$notify({
              title: 'Error',
              text: this.$static('ceo.slider-link-error', 'Перевірте правильність посилань для слайдера.Також посилання не повинні містити недопустимі символи: < > " \' \\ {}[] | ^ ~ або пробіли.'),
              type: 'error',
              duration: 4000
            });
            return false;
          }
          return true;
        });
      }

      if (!isValid) return false;


      return true;
    }
  },
  watch: {
    name(name) {
      this.html = '';
      this.fetchTemplate(name);
      if (name === 'home') {
        api.get('/api/options').then(response => response.data).then(data => {
          this.$store.commit('setOptions', data);
        });
      }
    }
  }
}
</script>

<style scoped></style>